export default "__VITE_ASSET__f94ff27f__"